import { Injectable } from '@angular/core';
import { Label } from '@veritas-shared/models/label';

@Injectable({
  providedIn: 'root'
})
export class FilterConfigService {
  public getByLabels = <T extends { labels: Label[] }>(
    filterBy: string, values: T[]
  ): T[] => {
    if (!filterBy) return values;
    return values?.filter((value: T) => value?.labels?.findIndex((item) => item?.name === filterBy) > -1)
  }

  public getLabels = <T extends { labels: Label[] }>(values: T[]): Label[] => {
    if (!values?.length) return [];
    const result: Label[] = [];

    values?.forEach((value: T) => {
      value?.labels?.forEach((label: Label) => {
        const isSame = result?.some((item) => item?.id === label?.id);
        if (!isSame) result?.push(label);
      });
    });

    return result;
  }
}
